module.exports = __webpack_public_path__ + "img/clean2.fd62d95e.png";